module.exports = __webpack_public_path__ + "static/img/qa.3af596d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qa.png
// module id = KIPD
// module chunks = 1